function grabFormAsObject(jqueryForm, limitToFields = []) {
    var data = jqueryForm.serializeArray();
    var obj = {};
    data.forEach(function (item) {
        obj[item.name] = item.value;
    });
    return obj;
}

function validateJsFormRequire(jqueryForm, shouldShow, limitToFields = []) {
    var hasError = false;
    jqueryForm.parents('form').find('[required],.show-required').each(function (el) {
        if (!jQuery(this).val() ||
            jQuery(this).attr('type') === 'email' && !validateEmail(jQuery(this).val()) ||
            jQuery(this).attr('type') === 'checkbox' && jQuery(this).prop('checked') == false) {
            jQuery(this).parents('.form__item').toggleClass('has--error', shouldShow);
            if ((limitToFields.length > 0) && (limitToFields.indexOf(jQuery(this).attr('name')) !== -1)) {
                hasError = true;
            }
        }
    });

    return hasError;
}

function isCaptchaChecked() {
    return grecaptcha && grecaptcha.getResponse().length !== 0;
}

function facebookLogin(data) {
    apiGetCall('user/fblogin', data, (error, result) => {
        if (error) {
            $('.js-error-login').text(result.error).removeClass('d-none')
            window.scrollTo(0, 0);
            setTimeout(function () {
                $('.js-error-login').addClass('d-none');
            }, 3200);
        }
        let expires = (data.remember === undefined) ? 1 : 365;

        if (result.token) {
            Cookies.set("token", result.token, { expires });
            window.location.href = localize.siteurl;
        }
    });
    return false;
}
